import axios from "axios";
import { urlAPI } from "../../config/config";
import { showSnackbar } from "../../redux/actions";
import { IPayrollShuttleEntry } from "../../interface/payrollShuttle";

export const getPayrollShuttle = async (
    year: number,
    month: number,
    token: string,
    setEntries: (entries: IPayrollShuttleEntry[]) => void,
    dispatch: Function,
    setError: Function
) => {
    try {
        const response = await axios.get(`${urlAPI}/payroll-shuttle/${year}/${month}`, {
            headers: { Authorization: `Bearer ${token}` },
        });
        setEntries(response.data.message);
    } catch (error: any) {
        console.error(error);
        setError("Impossible de récupérer la navette de paie.");
        dispatch(showSnackbar("Erreur lors du chargement de la navette de paie.", "error"));
    }
};
